module.exports = __webpack_public_path__ + "static/wai-insights-caa54ec8025570906633a0f97b39829b.png";